const ACTION_NAMESPACE = '/RIB/COTISATION'

export const GET_RIB_COTISATION = `${ACTION_NAMESPACE}/GET_RIB`
export const GET_RIB_COTISATION_LOADING = `${ACTION_NAMESPACE}/GET_RIB_LOADING`
